import { render, staticRenderFns } from "./ExcluirCategorias.vue?vue&type=template&id=655f898b&scoped=true"
import script from "./ExcluirCategorias.vue?vue&type=script&lang=js"
export * from "./ExcluirCategorias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655f898b",
  null
  
)

export default component.exports